import React, { useCallback } from "react"
import { useSelector, useDispatch } from "react-redux";
import { Modal, Form, Input, Button, message } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import styles from "./index.module.less"

function LoginModal() {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user.user);
    console.log(user)
    const login = useCallback(({ username, password }) => {
        if (username !== "wb" || password !== "w123456b") {
            message.error("用户名或密码错误！")
            return;
        }
        dispatch.user.update({
            id: 5,
            mail: "2872401656@qq.com",
            userName: username,
        })
    }, [dispatch])
    if (!user) return null;
    return (
        <Modal
            visible={!user}
            destroyOnClose
            closable={false}
            footer={null}
            centered
            className={styles.loginModal}
            width={400}
            bodyStyle={{ padding: 0 }}
        >
            <div className="login-title">
                <div className="icon">
                    <img src="/navigate/images/planetsmovement.png" alt="" />
                </div>
                <div className="content">
                    <img src="/navigate/images/logo.png" alt="" />
                    <div className="login-description">Welcome to RouteView</div>

                </div>
            </div>
            <div className="login-body">
                <Form
                    name="normal_login"
                    className="login-form"
                    initialValues={{ remember: true }}
                    onFinish={login}
                    style={{ margin: "0 auto" }}
                    size="large"
                >
                    <Form.Item
                        name="username"
                        rules={[{ required: true, message: 'Please input your Username!' }]}
                    >
                        <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Username" />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        rules={[{ required: true, message: 'Please input your Password!' }]}
                    >
                        <Input
                            prefix={<LockOutlined className="site-form-item-icon" />}
                            type="password"
                            placeholder="Password"
                        />
                    </Form.Item>
                    <Form.Item>
                        <Button block type="primary" htmlType="submit" className="login-form-button">
                            Log in
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    )
}

export default LoginModal